import CrossIcon from "@assets/icons/cross.svg";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import React, { forwardRef, HTMLAttributes } from "react";

interface OnboardingPanelProps extends HTMLAttributes<HTMLDivElement> {
	text: string;
	onClose: (event: React.MouseEvent<SVGElement, MouseEvent>) => void;
}

export const OnboardingPanel = forwardRef<HTMLDivElement, OnboardingPanelProps>(({ onClose, text, ...props }, ref) => (
	<Container ref={ref} {...props}>
		<p className="p-size-s-bold">{text}</p>
		<StyledCrossIcon width={24} height={24} color={colors.white} onClick={onClose} />
	</Container>
));

OnboardingPanel.displayName = "OnboardingPanel";

const Container = styled.div`
	position: relative;
	padding: 12px 40px 12px 12px;
	background-color: ${colors.onboardingPrimary};
	border-radius: 8px;
	color: ${colors.white};
`;

const StyledCrossIcon = styled(CrossIcon)`
	position: absolute;
	top: 10px;
	right: 10px;
	cursor: pointer;
`;
